// German for the login screen. Pre-auth there is no LocaleProvider above the page, so this
// catalogue is also exported: LoginPage.tsx reads it directly, keyed by the browser language,
// and registers it here for the rest of the console.
import { registerDe } from '../i18n/index.js';
import type { Dict } from '../../shared/i18n.js';

export const de: Dict = {
  'Sign in': 'Anmelden',
  'Signing in…': 'Anmeldung läuft…',
  'Access to the relationship record': 'Zugang zum Beziehungsregister',
  'Email': 'E-Mail',
  'Password': 'Passwort',
  'your@email.ch': 'ihre@email.ch',
  'Enter your password': 'Passwort eingeben',
  'Log in with SSO': 'Mit SSO anmelden',
  'Email is required': 'E-Mail-Adresse ist erforderlich',
  'Password is required': 'Passwort ist erforderlich',
  'Login failed': 'Anmeldung fehlgeschlagen',
  'Your email is not authorized to access this application. Contact an administrator.':
    'Ihre E-Mail-Adresse ist für diese Anwendung nicht freigegeben. Wenden Sie sich an eine Administratorin oder einen Administrator.',
  'Authentication failed. Please try again.': 'Die Anmeldung ist fehlgeschlagen. Bitte versuchen Sie es erneut.',
  'No email was received from the identity provider.': 'Vom Identitätsanbieter wurde keine E-Mail-Adresse übermittelt.',
  'Only pre-approved email addresses can log in.':
    'Nur freigegebene E-Mail-Adressen können sich anmelden.',
};

registerDe(de, 'LoginPage');
